import React, { Component } from 'react';

import axios from 'axios';

import { /* get_FetchPortletList */ get_GetPortlet } from '../../../../config/urls.js';

import { getXSRFToken } from "../../../../utils/xsrf-token-header";

import './index.css';
class PortletModal extends Component {

  constructor() {
    super();

    this.state = {
      routes: null,
      fetching: true
    }

    this.fetchRoutes = this.fetchRoutes.bind(this);
  }


  componentDidMount() {
    this.fetchRoutes();
  }


  render() {


    let content = null;

    if(this.state.fetching) {
      content = <div>Fetching...</div>
    } else if (this.state.routes && this.state.routes.length > 0) {

      let routes = this.state.routes.map((item) => {
        return (
          <tr key={item.id}>
            <td>{item.id}</td>
            <td>{item.route}</td>
            <td>{item.stripPrefix ? 'Yes' : 'No'}</td>
            <td>{item.url}</td>
            <td>{item.ignoreHeaders}</td>
          </tr>
        )
      });

      content = (
        <table>

          <thead>
            <tr>
              <td>Id</td>
              <td>Route</td>
              <td>Strip Prefix</td>
              <td>Url</td>
              <td>Ignore Headers</td>
            </tr>
          </thead>

          <tbody>
            {routes}
          </tbody>

        </table>
      )
    } else if(this.state.routes && this.state.routes.length === 0) {
      content = <div>No routes</div>
    } else {
      content = <div>Error fetching routes</div>
    }




    return (
      <div className="portlet_modal_wrapper">
        <div className="container">
          <div className="header">
            <div className="text">Portlet ID : {this.props.portletData.portletId}</div>
            <div className="icon" onClick={this.props.buttonHandler}>{closeIcon}</div>
          </div>
          <div className="content">

            <div className="title">Portlet Details</div>


            <div className="item_box">

              <div className="item">
                <div className="label">Name</div>
                <div className="val">{this.props.portletData.name}</div>
              </div>

              <div className="item">
                <div className="label">App Id</div>
                <div className="val">{this.props.portletData.appId}</div>
              </div>

            </div>


            <div className="item_box">

              <div className="item">
                <div className="label">Base Path</div>
                <div className="val">{this.props.portletData.basePath}</div>
              </div>
              <div className="item">
                <div className="label">SPA</div>
                <div className="val">{this.props.portletData.spa ? 'Yes' : 'No'}</div>
              </div>

            </div>


            <div className="item">
              <div className="label">Index Path</div>
              <div className="val">{this.props.portletData.indexPath}</div>
            </div>

            <div className="item">
              <div className="label">Thumbnail</div>
              <div className="val">{this.props.portletData.thumbnail}</div>
            </div>

            <div className="item">
              <div className="label">Logo Path</div>
              <div className="val">{this.props.portletData.logo}</div>
            </div>

            <div className="item">
              <div className="label">Authority Level</div>
              <div className="val">{this.props.portletData.authorityLevel}</div>
            </div>


            <div className="route_area">
              <div className="title">Routes</div>

              {content}

            </div>

          </div>
        </div>
      </div>
    );
  }


  fetchRoutes() {

    const requestTool = axios.create({
      timeout: 60000,
      headers: {
        ...getXSRFToken()
        // 'Content-Type': 'multipart/form-data'
      }
    });


    requestTool.get(get_GetPortlet(this.props.portletData.portletId), {})
      .then((res) => {
        let data = res.data.routes;

        this.setState({
          fetching: false,
          routes: data
        });
      })
      .catch((err) => {
        this.setState({
          fetching: false
        });
      });


  }
}

export default PortletModal;





const closeIcon = (
  <svg viewBox="0 0 21.9 21.9">
    <path d="M14.1,11.3c-0.2-0.2-0.2-0.5,0-0.7l7.5-7.5c0.2-0.2,0.3-0.5,0.3-0.7s-0.1-0.5-0.3-0.7l-1.4-1.4C20,0.1,19.7,0,19.5,0  c-0.3,0-0.5,0.1-0.7,0.3l-7.5,7.5c-0.2,0.2-0.5,0.2-0.7,0L3.1,0.3C2.9,0.1,2.6,0,2.4,0S1.9,0.1,1.7,0.3L0.3,1.7C0.1,1.9,0,2.2,0,2.4  s0.1,0.5,0.3,0.7l7.5,7.5c0.2,0.2,0.2,0.5,0,0.7l-7.5,7.5C0.1,19,0,19.3,0,19.5s0.1,0.5,0.3,0.7l1.4,1.4c0.2,0.2,0.5,0.3,0.7,0.3  s0.5-0.1,0.7-0.3l7.5-7.5c0.2-0.2,0.5-0.2,0.7,0l7.5,7.5c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3l1.4-1.4c0.2-0.2,0.3-0.5,0.3-0.7  s-0.1-0.5-0.3-0.7L14.1,11.3z" />
  </svg>
);


// WEBPACK FOOTER //
// ./src/routes/portlets/components/PortletModal/index.js